// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3yrH9juWiD9qrzDMVp1E0J","chipsWrapper":"_3A42_VDecTyYDDM9ldNVF5","additionalFiltersTitle":"_3UY1pbJoaT6XRKwE0q3pOt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignPagePropertiesContainer/ForeignPagePropertiesContainer.scss
// module id = 1823
// module chunks = 0